export default __webpack_public_path__ + "static/media/arteveldehs.884515e6.svg";